<template>
  <div class="wrapper">
    <img
      alt="terms & condition"
      class="image"
      src="@/assets/terms_&_conditions.svg"
    />
    <h3 class="title">{{ $t('dialogs.acceptTermsTitle') }}</h3>
    <p class="description">{{ $t('dialogs.acceptTermsDescription') }}</p>
    <div class="inputWrapper">
      <Checkbox
        v-model="checked"
        :binary="true"
        class="checkbox"
        input-id="accept-checkbox"
      />
      <label class="accept-label" for="accept-checkbox">
        {{ $t('dialogs.iAccept') }}
      </label>
      <router-link class="link" target="_blank" to="/terms">
        {{ $t('dialogs.termsAndConditions') }}
      </router-link>
    </div>
    <PButton
      :disabled="!checked"
      class="accept_button p-button-primary"
      @click="handleClick"
    >
      {{ $t('common.continue') }}
    </PButton>
  </div>
</template>

<script lang="ts" setup>
import { inject, ref } from 'vue';
import Checkbox from 'primevue/checkbox';
import { useRoute } from 'vue-router';
import { useStore } from '@/store';

const dialogRef = inject('dialogRef');
const mainStore = useStore();
const checked = ref(false);

type IProps = {
  visible?: boolean;
};
defineProps<IProps>();
defineEmits(['update:visible']);
const route = useRoute();

const onClose = () => {
  mainStore.showTermsAndConditions.value = !checked.value;
  const isStakesPage = route.name === 'stakes';
  dialogRef.value.close({ isStakesPage });
};

const handleClick = () => {
  onClose();
};

if (route.fullPath === '/terms') {
  setTimeout(() => {
    onClose();
  }, 0);
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .title {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
    margin: 50px 0 16px;
  }

  .description {
    font-family: Roboto;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.4399999976158142px;
    text-align: center;
    margin: 0 0 24px;
  }
  .inputWrapper {
    position: relative;
    padding: 16px;
    border-radius: 8px;
    background-clip: padding-box;
    box-sizing: border-box;
    $border: 1px;
    border: solid $border transparent;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 24px;
    & > * {
      z-index: 2;
    }
    &:before {
      content: ' ';
      position: absolute;
      top: -$border;
      right: -$border;
      bottom: -$border;
      left: -$border;
      z-index: 0;
      border-radius: inherit;
      background: linear-gradient(to right, #6e42ca, #8d29c1);
    }
    &:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      background: #28253e;
      border-radius: inherit;
      z-index: 1;
    }
  }
  .accept-label {
    margin-left: 12px;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.4399999976158142px;
    text-align: left;
  }
  .link {
    color: #946bec;
    text-decoration: none;
    margin-left: 5px;
  }
  .accept_button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep(.checkbox.p-checkbox) {
    .p-checkbox-box {
      border: 1.5px solid #7b7192;
      background: transparent;
      box-shadow: none;
    }
    .p-checkbox-box.p-highlight {
      border-color: #6e42ca;
      background: #6e42ca;
    }
    .p-checkbox-icon {
      color: white;
      font-weight: 900;
    }
  }
}
</style>
